import isEmpty from 'lodash/isEmpty';

export function getMenu(hasPermission) {
  return [
    { type: '任务列表', path: '/task/list', codes: ['taskList'] },
    { type: '历史任务', path: '/task/history', codes: ['taskHistory'] },
    { type: '统计分析', path: '/task/analysis', codes: ['statisticAnalysis'] }
  ].filter(m => {
    if (isEmpty(m.codes)) {
      return true;
    }
    if (m.codes.some(code => hasPermission(code))) {
      return true;
    }
    return false;
  });
}
